export default __webpack_public_path__ + "static/media/male.6d1644ec.png";